import Vue from 'vue';
import BootstrapVue from "bootstrap-vue";
import bEmbed from 'bootstrap-vue/es/components/embed/embed';
import App from './App.vue';
import MenuMain from './components/MenuMain.vue';
import Banner from './components/Banner.vue';
import Services from './components/Services.vue';
import CanalYoutube from './components/CanalYoutube.vue';
import Footer from './components/Footer.vue';

Vue.component('app-menu', MenuMain);
Vue.component('app-banner', Banner);
Vue.component('app-services', Services);
Vue.component('app-canal-youtube', CanalYoutube);
Vue.component('app-footer', Footer);
Vue.component('b-embed', bEmbed);

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js